export default __webpack_public_path__ + "static/media/Ts_2020-4-1.f4bd2982.png";